import { render, staticRenderFns } from "./PricingBanner.vue?vue&type=template&id=1faf032d&scoped=true"
import script from "./PricingBanner.vue?vue&type=script&lang=ts"
export * from "./PricingBanner.vue?vue&type=script&lang=ts"
import style0 from "./PricingBanner.vue?vue&type=style&index=0&id=1faf032d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf032d",
  null
  
)

export default component.exports